import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router";

import Checkbox from "../../Common/Forms/Checkbox";
import EditableFieldJira from "../../Common/Forms/EditableFieldJiraForTable";
import OpenMakulerModal from "../../Common/IleggelseClient/OpenMakulerModal";
import MakulerModalContainer from "../../Common/MakulerModalContainer";
import Table from "../../Common/SortableTableContainer";
import { HeaderCell } from "../../Common/Tables";

import { getEttersendelserTilGodkjenning as getEttersendelserTilGodkjenningAction } from "../../../actions/ettersendelserTilGodkjenningActions";
import { putIleggelseEttersendelser as putIleggelseEttersendelserActions } from "../../../actions/ileggelseEttersendelserActions";
import { postIleggelserMakulering as postIleggelserMakuleringAction } from "../../../actions/ileggelseMakuleringerActions";
import sitePaths from "../../../constants/sitePaths";

export default function ListContainer({
  checkedEttersendelserTilGodkjenning,
  handleCheckboxChange,
  getEttersendelserTilGodkjenningFilter,
}) {
  const dispatch = useDispatch();
  const ettersendelserTilGodkjenning = useSelector(
    (state) =>
      state.ettersendelserTilGodkjenning &&
      state.ettersendelserTilGodkjenning.items,
  );

  const putIleggelseEttersendelserHandler = (ettersendelseId, name, value) => {
    const ileggelseWithEttersendelseId = ettersendelserTilGodkjenning
      .map((etg) => etg.ettersendelse)
      .filter((etg) => etg.id === ettersendelseId);
    const data = {
      navn: ileggelseWithEttersendelseId[0].navn,
      gate: ileggelseWithEttersendelseId[0].gate,
      postnummer: ileggelseWithEttersendelseId[0].postnummer,
      poststed: ileggelseWithEttersendelseId[0].poststed,
    };
    dispatch(
      putIleggelseEttersendelserActions(ettersendelseId, {
        ...data,
        [name]: value,
      }),
    )
      .then(() =>
        dispatch(
          getEttersendelserTilGodkjenningAction(
            getEttersendelserTilGodkjenningFilter(),
          ),
        ),
      )
      .catch();
  };

  const postIleggelserMakulering = (ileggelseId, kommentar) => {
    return dispatch(postIleggelserMakuleringAction(ileggelseId, kommentar))
      .then(() =>
        dispatch(
          getEttersendelserTilGodkjenningAction(
            getEttersendelserTilGodkjenningFilter(),
          ),
        ),
      )
      .catch(() => Promise.reject(true));
  };

  const renderRow = (ettersendelseTilGodkjenning) => {
    if (
      ettersendelseTilGodkjenning &&
      ettersendelseTilGodkjenning.ettersendelse
    ) {
      const ettersendelseId =
        ettersendelseTilGodkjenning &&
        ettersendelseTilGodkjenning.ettersendelse &&
        ettersendelseTilGodkjenning.ettersendelse.id;
      return (
        <tr
          key={`ettersendelserTilGodkjenningTableBodyTr${ettersendelseTilGodkjenning.id}`}
        >
          <td>
            <Checkbox
              id={`checkbox${ettersendelseId}EttersendelserTilGodkjenning`}
              name={ettersendelseId}
              checkedValue={true}
              uncheckedValue={false}
              currentValue={
                checkedEttersendelserTilGodkjenning[ettersendelseId]
              }
              handleChange={handleCheckboxChange}
            />
          </td>
          <td>
            <Link
              to={`${sitePaths.ileggelser.ettersendelserTilGodkjenning.shortUrl}/${ettersendelseTilGodkjenning.id}`}
              className="underline"
            >
              {ettersendelseTilGodkjenning.ileggelsesnummer}
            </Link>
          </td>
          <td>
            {ettersendelseTilGodkjenning.ileggelsesdatoTil &&
              new Date(
                ettersendelseTilGodkjenning.ileggelsesdatoTil,
              ).toLocaleDateString("nb-NO", {
                timeZone: "Europe/Oslo",
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
          </td>
          <td>{ettersendelseTilGodkjenning.kjennemerke}</td>
          <td>{ettersendelseTilGodkjenning.nasjon}</td>
          <td style={{ paddingTop: 5, paddingBottom: 3 }}>
            <EditableFieldJira
              inputId="navn"
              objectId={ettersendelseTilGodkjenning.ettersendelse.id}
              name="navn"
              value={
                (ettersendelseTilGodkjenning.ettersendelse &&
                  ettersendelseTilGodkjenning.ettersendelse.navn) ||
                ""
              }
              onSubmit={putIleggelseEttersendelserHandler}
            />
          </td>
          <td style={{ paddingTop: 5, paddingBottom: 3 }}>
            <EditableFieldJira
              inputId="gate"
              objectId={ettersendelseTilGodkjenning.ettersendelse.id}
              name="gate"
              value={
                (ettersendelseTilGodkjenning.ettersendelse &&
                  ettersendelseTilGodkjenning.ettersendelse.gate) ||
                ""
              }
              onSubmit={putIleggelseEttersendelserHandler}
            />
          </td>
          <td style={{ paddingTop: 5, paddingBottom: 3 }}>
            <EditableFieldJira
              inputId="postnummer"
              objectId={ettersendelseTilGodkjenning.ettersendelse.id}
              name="postnummer"
              value={
                (ettersendelseTilGodkjenning.ettersendelse &&
                  ettersendelseTilGodkjenning.ettersendelse.postnummer) ||
                ""
              }
              onSubmit={putIleggelseEttersendelserHandler}
            />
          </td>
          <td style={{ paddingTop: 5, paddingBottom: 3 }}>
            <EditableFieldJira
              inputId="poststed"
              objectId={ettersendelseTilGodkjenning.ettersendelse.id}
              name="poststed"
              value={
                (ettersendelseTilGodkjenning.ettersendelse &&
                  ettersendelseTilGodkjenning.ettersendelse.poststed) ||
                ""
              }
              onSubmit={putIleggelseEttersendelserHandler}
            />
          </td>
          <td>
            <MakulerModalContainer
              id={ettersendelseTilGodkjenning.id}
              ileggelsesnummer={ettersendelseTilGodkjenning.ileggelsesnummer}
              titleType="ileggelse"
              openMakulerModal={OpenMakulerModal}
              postMakulering={postIleggelserMakulering}
            />
          </td>
        </tr>
      );
    }
    return;
  };

  return (
    <Table
      id="ettersendelseTilGodkjenning-liste"
      className="bym-ettersendelser-til-godkjenning-table"
      storeKey="ileggelser"
      items={ettersendelserTilGodkjenning}
      renderRow={renderRow}
    >
      <HeaderCell>
        <Checkbox
          id="checkboxAllEttersendelserTilGodkjenning"
          name="checkboxAllEttersendelserTilGodkjenning"
          checkedValue={true}
          uncheckedValue={false}
          currentValue={
            checkedEttersendelserTilGodkjenning.checkboxAllEttersendelserTilGodkjenning
          }
          handleChange={handleCheckboxChange}
        />
      </HeaderCell>
      <HeaderCell>Ilegg.nr.</HeaderCell>
      <HeaderCell>Ilegg.dato</HeaderCell>
      <HeaderCell>Kj.merke</HeaderCell>
      <HeaderCell>Nasjonalitet</HeaderCell>
      <HeaderCell>Navn</HeaderCell>
      <HeaderCell>Adresse</HeaderCell>
      <HeaderCell>Postnr.</HeaderCell>
      <HeaderCell>Poststed</HeaderCell>
      <HeaderCell />
    </Table>
  );
}
